<template>
  <v-card v-if="drug" class="white references" :max-width="_getMaxWidth()">
    <div class="references-header" ref="referencesHeader">
      <vetalfa-small-header
        :title="_getLabel('REFERENCES')"
        :hasShareOption="false"
      ></vetalfa-small-header>
      <vetalfa-drugs-header
        v-if="drug"
        :name="drug.name"
        :description="drug.description"
      ></vetalfa-drugs-header>
    </div>
    <div ref="referencesContent">
      <vetalfa-section-title :prop="labels.REFERENCES">
        <v-row class="ma-0 pa-0 pa-2">
          <v-col class="ma-0 pa-0" cols="12">
            <p class="ma-0 pa-0 reference-text">
              {{ `${labels.REFERENCE_CARD_NAME}: ${reference.name}` }}
            </p>
            <p class="ma-0 pa-0 mt-5 reference-text">
              {{ `${labels.REFERENCE_CARD_YEAR}: ${reference.year}` }}
            </p>
            <p class="ma-0 pa-0 mt-1 reference-text">
              {{
                `${labels.REFERENCE_CARD_MAGAZINE}: ${_capitalize(
                  reference.magazine
                )}`
              }}
            </p>
            <p class="ma-0 pa-0 mt-2 reference-text">
              {{ `${labels.REFERENCE_CARD_SITE}: ` }}
              <span
                @click="
                  openExternalUrl({ url: reference.link, inAppBrowser: true })
                "
                class="reference-link"
                >{{ reference.link }}</span
              >
            </p>
            <p class="ma-0 pa-0 mt-1 reference-text">
              {{
                `${labels.REFERENCE_CARD_EVIDENCE_LEVEL}: ${reference.level}`
              }}
            </p>
            <p v-if="reference.addendum" class="ma-0 pa-0 mt-1">
              {{ `${labels.ADDENDA}: ${reference.addendum}` }}
            </p>
          </v-col>
          <v-col class="ma-0 pa-0 mt-2" cols="12">
            <v-row class="ma-0 pa-0" align="center" justify="center">
              <v-img
                max-width="30%"
                :src="pyramid_image"
                :lazy-src="pyramid_image"
                class
              ></v-img>
            </v-row>
          </v-col>
        </v-row>
      </vetalfa-section-title>
      <vetalfa-section-title :prop="labels.REFERENCES_KNOW_MORE">
        <v-row class="ma-0 pa-0 pa-2">
          <v-col class="ma-0 pa-0" cols="12">
            <p class="reference-levels">{{ labels.REFERENCES_LEVELS }}</p>
          </v-col>
          <v-col class="ma-0 pa-0" cols="12">
            <p class="ma-0 pa-0 reference-text">
              {{ `${labels.REFERENCE_MORE_INFO}: ` }}
              <span
                @click="
                  openExternalUrl({
                    url: labels.REFERENCES_KNOW_MORE_SITE,
                    inAppBrowser: true,
                  })
                "
                class="reference-link"
                >{{ labels.REFERENCES_KNOW_MORE_SITE }}</span
              >
            </p>
          </v-col>
          <v-col class="ma-0 pa-0 mt-5" cols="12">
            <v-row class="ma-0 pa-0" align="center" justify="center">
              <v-img
                max-width="30%"
                :src="images.PYRAMID"
                :lazy-src="images.PYRAMID"
                class
              ></v-img>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0 mt-2" cols="12">
            <vetalfa-section-item-title :prop="labels.REFERENCES_WHAT_IS">
              <vetalfa-section-paragraph
                prop="No coração da medicina veterinária baseada em evidência está o desejo de aliar o melhor cuidado e tratamento aos nossos pacientes e tutores às melhores evidências científicas disponíveis."
              ></vetalfa-section-paragraph>
              <vetalfa-section-paragraph
                prop="Acreditamos que a prática da medicina veterinária de ponta em sua plenitude se dá quando nós, clínicos, temos respeito e cuidado com a vida de nossos pacientes. Isso significa ter atenção ao corpo de evidências e capacidade de discernir quais são as mais confiáveis — sempre usando o nosso saber clínico para aplicar o que melhor se adequa ao nosso paciente."
              ></vetalfa-section-paragraph>
              <vetalfa-section-paragraph
                prop="Sabemos que em um mundo de grande oferta de informações, com alguma frequência acabamos nos prendendo a opiniões e conteúdos não substanciados por evidências confiáveis. Daí a necessidade de um sistema de avaliação rápido das evidências, que possa nos auxiliar no dia a dia e que proporcione o melhor tratamento aos nossos pacientes."
              ></vetalfa-section-paragraph>
              <vetalfa-section-paragraph
                prop="A pirâmide de evidências (hierarquia de evidências) tem o objetivo de classificar as evidências em níveis, proporcionando ao leitor uma heurística para discernir evidências mais ou menos confiáveis:"
              ></vetalfa-section-paragraph>
              <vetalfa-section-item
                prop="Estudos mais próximos ao topo da pirâmide (Evidência 1) possuem um menor risco de viés e nos aproximam mais da verdade."
              >
                <vetalfa-section-sub-item
                  prop="Exemplo de um estudo nível 1: Review sistemático de estudos randomizados controlados."
                ></vetalfa-section-sub-item>
              </vetalfa-section-item>
              <vetalfa-section-item
                :index="true"
                prop="Estudos mais próximos à base da pirâmide (Evidência 5) possuem um maior risco de viés e podem não nos aproximar tanto da verdade."
              >
                <vetalfa-section-sub-item
                  prop="Exemplos de estudos nível 5: Artigos baseados puramente em opiniões e estudos fisiológicos in-vitro."
                ></vetalfa-section-sub-item>
              </vetalfa-section-item>
              <vetalfa-section-paragraph
                prop="A classificação utilizada em nosso sistema se inspirou na metodologia utilizada pelo Centro de medicina baseada em evidência da University of Oxford."
              ></vetalfa-section-paragraph>
            </vetalfa-section-item-title>
          </v-col>
        </v-row>
      </vetalfa-section-title>
    </div>
    <div class="navigation-blank-space"></div>
  </v-card>
</template>

<style>
.references {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: 100%;
  width: 100%;
  border-radius: 0px;
}
.references-header {
  color: transparent;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5;
  max-width: 768px;
  background-color: white;
}
.reference-text {
  font-size: 14px;
  font-weight: 0;
  color: #393a3a;
}
.reference-link {
  font-size: 14px;
  color: #004662;
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0;
  text-decoration: underline;
  cursor: pointer;
}
.reference-levels {
  color: #393a3a;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import labels from "@/constants/labels.js";
import images from "@/constants/images.js";
export default {
  name: "References",
  methods: {
    ...mapActions("general", ["openExternalUrl"]),
    setupScreenSizes() {
      setTimeout(
        function () {
          if (this.$refs.referencesHeader && this.$refs.referencesContent) {
            this.headerHeight = this.$refs.referencesHeader.offsetHeight + 1;
            this.$refs.referencesContent.style.paddingTop =
              this.headerHeight + "px";
            this.$vuetify.goTo(0, {
              duration: 0,
              offset: 0,
              easing: "easeInOutCubic",
            });
            return;
          }
          this.setupScreenSizes();
        }.bind(this),
        100
      );
    },
  },
  computed: {
    ...mapGetters("drugs", ["drug", "reference"]),
    pyramid_image() {
      let level = this.reference.levelNumber || Number(this.reference.level);
      if (!isNaN(this.reference.level) || this.reference.levelNumber) {
        return {
          1: this.images.PYRAMID_ONE,
          2: this.images.PYRAMID_TWO,
          3: this.images.PYRAMID_THREE,
          4: this.images.PYRAMID_FOUR,
          5: this.images.PYRAMID_FIVE,
        }[level];
      }
    },
  },
  data() {
    return {
      labels,
      images,
    };
  },
  mounted() {
    this.setupScreenSizes();
  },
  created() {
    if (!this.drug || !this.reference) {
      this.$router.push("/");
    }
  },
};
</script>